import axiosInstance from './axiosInstance';

const getAdmins = () => {
  return axiosInstance.get('/internal/admin/admins');
};

export default getAdmins;
